import {
  Package,
  Layers,
  Zap,
  AlignLeft,
  Languages,
  FileText,
  GraduationCap,
  Film,
  Bot
} from 'lucide-react';
import { PlanBo } from '@utils/types/back-office/update-plan-bo.ts';

export interface FeatureOption {
  key: keyof Pick<
    PlanBo,
    | 'batch_enabled'
    | 'realtime_enabled'
    | 'alignment_enabled'
    | 'translation_enabled'
    | 'templates_exported_enabled'
    | 'automatic_training_enabled'
    | 'allow_burnt_export'
    | 'ai_summaries_enabled'
  >;
  label: string;
  icon: typeof Package;
  color: string;
  bgColor: string;
}

export const FEATURE_OPTIONS: FeatureOption[] = [
  {
    key: 'batch_enabled',
    label: 'batch-stt',
    icon: Layers,
    color: 'rgba(59, 130, 246, 0.7)',
    bgColor: 'rgba(59, 130, 246, 0.05)'
  },

  {
    key: 'realtime_enabled',
    label: 'realtime-stt',
    icon: Zap,
    color: 'rgba(139, 92, 246, 0.7)',
    bgColor: 'rgba(139, 92, 246, 0.05)'
  },

  {
    key: 'alignment_enabled',
    label: 'alignment',
    icon: AlignLeft,
    color: 'rgba(16, 185, 129, 0.7)',
    bgColor: 'rgba(16, 185, 129, 0.05)'
  },

  {
    key: 'translation_enabled',
    label: 'translation',
    icon: Languages,
    color: 'rgba(245, 158, 11, 0.7)',
    bgColor: 'rgba(245, 158, 11, 0.05)'
  },

  {
    key: 'templates_exported_enabled',
    label: 'export-templates',
    icon: FileText,
    color: 'rgba(236, 72, 153, 0.7)',
    bgColor: 'rgba(236, 72, 153, 0.05)'
  },

  {
    key: 'automatic_training_enabled',
    label: 'automatic-training',
    icon: GraduationCap,
    color: 'rgba(99, 102, 241, 0.7)',
    bgColor: 'rgba(99, 102, 241, 0.05)'
  },

  {
    key: 'allow_burnt_export',
    label: 'burned-in-export',
    icon: Film,
    color: 'rgba(234, 88, 12, 0.7)',
    bgColor: 'rgba(234, 88, 12, 0.05)'
  },

  {
    key: 'ai_summaries_enabled',
    label: 'ai-summaries',
    icon: Bot,
    color: 'rgba(20, 184, 166, 0.7)',
    bgColor: 'rgba(20, 184, 166, 0.05)'
  }
];
